import { ColumnViewModel } from '../../shared/column-types';

export const GENES_GDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneEnsemblIDs',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'source',
    'sentenceHTML',
    'chemsInSentence',
    'chemIDs',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'chemical_effect',
    'reference',
    'reference_type',
    'association',
    'citation_count',
  ],
  defaultVisible: [
    'diseaseName',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'reference',
    'reference_type',
  ],
};